import { useCallback, useEffect, useState } from "react";
import { Wrench } from "lucide-react";
import { api } from "@/lib/api";
import { Logo } from "@/components/Logo";

const pad = (n) => String(n).padStart(2, "0");

const MaintenancePage = ({ m, now }) => {
  const s = Math.max(0, Math.floor((new Date(m.until).getTime() - now) / 1000));
  const parts = [[Math.floor(s / 3600), "jam"], [Math.floor((s % 3600) / 60), "menit"], [s % 60, "detik"]];
  return (
    <div className="min-h-screen bg-paper flex flex-col items-center justify-center px-6 text-center" data-testid="maintenance-page">
      <Logo />
      <div className="mt-10 w-16 h-16 rounded-2xl bg-forest text-paper grid place-items-center animate-pulse"><Wrench className="w-8 h-8" /></div>
      <h1 className="font-serif font-bold text-4xl sm:text-5xl text-ink mt-6">Sedang update</h1>
      <p className="text-muted2 mt-3 max-w-md">{m.message || "Kami sedang memperbarui sistem agar pesananmu makin lancar. Pemesanan dibuka kembali setelah hitung mundur selesai."}</p>
      <div className="flex gap-3 mt-8" data-testid="maintenance-countdown">
        {parts.map(([v, l]) => (
          <div key={l} className="bg-forest text-paper rounded-2xl w-24 py-4">
            <div className="font-bold text-4xl tabular-nums">{pad(v)}</div>
            <div className="text-xs uppercase tracking-wider opacity-80 mt-1">{l}</div>
          </div>
        ))}
      </div>
      <p className="text-xs text-muted2 mt-8">uplinkcoffee.com</p>
    </div>
  );
};

export const MaintenanceGate = ({ children }) => {
  const [m, setM] = useState(null);
  const [now, setNow] = useState(Date.now());
  const check = useCallback(() => { api.get("/status").then((r) => setM(r.data.maintenance)).catch(() => {}); }, []);
  useEffect(() => {
    check();
    const poll = setInterval(check, 30000);
    const tick = setInterval(() => setNow(Date.now()), 1000);
    return () => { clearInterval(poll); clearInterval(tick); };
  }, [check]);
  const active = m?.active && new Date(m.until).getTime() > now;
  useEffect(() => {
    if (m?.active && !active) check();
  }, [m, active, check]);
  return active ? <MaintenancePage m={m} now={now} /> : children;
};
